var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.923096,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#FD5161"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.923096,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7988 8.97048H10.2C9.09542 8.97048 8.20003 9.86588 8.20003 10.9705V14.5421C8.20003 15.6467 9.09542 16.5421 10.2 16.5421H13.7988C14.9034 16.5421 15.7988 15.6467 15.7988 14.5421V10.9705C15.7988 9.86588 14.9034 8.97048 13.7988 8.97048ZM14.2344 13.2023C14.0654 14.0935 13.3364 14.8224 12.4451 14.9913C10.841 15.2952 9.46076 13.9153 9.76416 12.3112C9.93269 11.4201 10.6613 10.691 11.5523 10.5214C13.1573 10.2162 14.5389 11.5973 14.2344 13.2023ZM14.3809 10.927C14.0842 10.927 13.8434 10.6864 13.8434 10.3896C13.8434 10.0928 14.0842 9.85215 14.3809 9.85215C14.6776 9.85215 14.9184 10.0927 14.9184 10.3896C14.9184 10.6866 14.6776 10.927 14.3809 10.927Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.983 6.77148H9.01563C7.35876 6.77148 6.01562 8.11462 6.01562 9.77148V15.741C6.01562 17.3979 7.35876 18.741 9.01563 18.741H14.9831C16.64 18.741 17.9831 17.3979 17.9831 15.741V9.77148C17.9831 8.11462 16.6399 6.77148 14.983 6.77148ZM16.4654 14.5421C16.4654 16.0148 15.2715 17.2088 13.7988 17.2088H10.2C8.72723 17.2088 7.53329 16.0148 7.53329 14.5421V10.9705C7.53329 9.49775 8.72723 8.30382 10.2 8.30382H13.7988C15.2715 8.30382 16.4654 9.49775 16.4654 10.9705V14.5421Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3594 11.3538C11.2852 11.093 10.3364 12.0411 10.5968 13.1154C10.7192 13.6206 11.1334 14.0352 11.6384 14.1584C12.7132 14.4205 13.6631 13.4713 13.4018 12.3962C13.279 11.891 12.8646 11.4766 12.3594 11.3538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.c7f28fc1b63a675c891272b83b7280c6.svg";
export { ForwardRef as ReactComponent };